import { render } from "./menuedit.vue?vue&type=template&id=42c09c05&scoped=true"
import script from "./menuedit.vue?vue&type=script&lang=js"
export * from "./menuedit.vue?vue&type=script&lang=js"

import "./menuedit.vue?vue&type=style&index=0&id=42c09c05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c09c05"]])

export default __exports__